import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TenantShellModule } from '../tenant-shell/tenant-shell.module';
import { MobileShellModule } from '../mobile-shell/mobile-shell.module';
import { PlatformService } from '../../core/platform/platform.service';

const TABLET_BREAKPOINT = 768;

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, TenantShellModule, MobileShellModule],
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, OnDestroy {
  isDesktopLayout = true;

  private readonly onResize = (): void => {
    this.updateLayoutMode();
  };

  constructor(private readonly platformService: PlatformService) {}

  ngOnInit(): void {
    if (!this.platformService.isBrowser()) {
      this.isDesktopLayout = true;
      return;
    }

    this.updateLayoutMode();
    this.platformService.addWindowEventListener('resize', this.onResize);
  }

  ngOnDestroy(): void {
    this.platformService.removeWindowEventListener('resize', this.onResize);
  }

  private updateLayoutMode(): void {
    this.isDesktopLayout = this.platformService.getViewportWidth() >= TABLET_BREAKPOINT;
  }
}
